/**
 * @file Выбор языка без зависимости от React.
 *
 * Приоритет: ручной выбор, первый поддерживаемый язык браузера, английский.
 * Ошибки localStorage не должны отключать переключение языка.
 */
export type Locale = 'ru' | 'en'

export const localeStorageKey = 'cloud-box.locale'

export function resolveLocale(
    saved: string | null,
    languages: readonly string[],
): Locale {
    if (saved === 'ru' || saved === 'en') return saved

    for (const language of languages) {
        const base = language.toLowerCase().split(/[-_]/)[0]
        if (base === 'ru' || base === 'en') return base
    }

    return 'en'
}

export function readLocale(
    storage: Pick<Storage, 'getItem'> | undefined,
    languages: readonly string[],
): Locale {
    try {
        return resolveLocale(
            storage?.getItem(localeStorageKey) ?? null,
            languages,
        )
    } catch {
        return resolveLocale(null, languages)
    }
}

export function saveLocale(
    storage: Pick<Storage, 'setItem'> | undefined,
    locale: Locale,
): void {
    try {
        storage?.setItem(localeStorageKey, locale)
    } catch {
        // Даже при заблокированном storage язык переключается в текущей вкладке.
    }
}
